import React, { Component } from 'react';
import { connect } from 'react-redux';
import SidebarList from 'features/Admin/components/SidebarList';
import ElementFocus from 'features/Admin/components/ElementFocus';
import {
	adminGetAllServipayTerminal,
	adminGetServipayTerminalById,
	adminPatchServipayTerminal,
	adminDeleteServipayTerminal,
	resetFocusServipayTerminal,
	adminPostServipayTerminal,
	initNewServipayTerminal,
} from 'services/servipayTerminal';
import { adminGetAllCenters } from 'services/center';
import AdminDataContainer from 'features/Admin/components/AdminDataContainer';
import { Grid, Icon } from 'semantic-ui-react';
import RedButton from 'components/Buttons/RedButton';
import GeneralForm from 'features/Admin/ServipayTerminal/Forms/GeneralForm';
import { Form, Formik } from 'formik';
import MainButton from 'components/Buttons/MainButton';
import SecondaryButton from 'components/Buttons/SecondaryButton';
import * as Yup from 'yup';

const schemaValidation = Yup.object().shape({
	label: Yup.string().required('Champ requis'),
	tid: Yup.string().required('Champ requis'),
    ip: Yup.string().required('Champ requis'),
    port: Yup.number().required('Champ requis'),
	
});

class ServipayTerminal extends Component {
	componentDidMount() {
		this.getAllElements();
	}

	componentWillUnmount() {
		this.props.resetFocusServipayTerminal();
	}

	componentDidUpdate(prevProps, prevState, snapshot) {}

	getAllElements = () => {
		this.props.adminGetAllCenters();
		this.props.adminGetAllServipayTerminal();
	};

	focusOnElement = (elt) => {
		this.props.adminGetServipayTerminalById(elt.id);
	};

	onAddClick = () => {
		this.props.initNewServipayTerminal();
	};

	saveFocus = (values, setSubmitting) => {
		if (values.id === undefined) {
			delete values.id;
			this.props.adminPostServipayTerminal(values).then(() => {
				setSubmitting(false);
			});
		} else {
			this.props.adminPatchServipayTerminal(values).then(() => {
				setSubmitting(false);
			});
		}
	};

	deleteFocus = () => {
		this.props.adminDeleteServipayTerminal(this.props.servipayTerminals.focus.data.id);
	};
	getCenterOptions = () => {
		if (this.props.centers && this.props.centers.list.data.length > 0){
			var centers = this.props.centers.list.data.filter(c => c.isCenter).map((c) => {return {value: c.id, label: c.name}})
			centers.unshift({value:0, label: '-'})
			return centers
		}
		return []
	}

	render() {
		const { servipayTerminals } = this.props;
		const { focus, list } = servipayTerminals;
		const servipayTerminal = focus.data;
		const newServipayTerminal = servipayTerminal !== null && servipayTerminal.id === undefined;

		return (
			<div style={styles.adminContainer}>
				<SidebarList
					list={servipayTerminals.list}
					categories={[]}
					onElementClick={this.focusOnElement}
					entity='Terminal Servipay'
					addButtonText='Nouveau Terminal Servipay'
					onAddButtonClick={this.onAddClick}
					defaultLabel={(e) => e.label}
					groupField={false}
					focusedEltId={servipayTerminal}
				/>

				<ElementFocus
					element={focus}
					list={list}
					entity='Terminal Servipay'
					icon='info'
				>
					{servipayTerminal !== null && (
						<Formik
							enableReinitialize
							initialValues={{
								id: servipayTerminal.id,
								label: servipayTerminal.label || '',
								tid: servipayTerminal.tid || '',
								ip: servipayTerminal.ip || '',
								port: servipayTerminal.port || 0,
								center: servipayTerminal.center || 0,
							}}
							validationSchema={schemaValidation}
							onSubmit={(values, { setSubmitting }) => {
								this.saveFocus(values, setSubmitting);
							}}
						>
							{({ isSubmitting, errors }) => (
								<Form>
									<Grid style={{ margin: 0 }}>
										<Grid.Row columns={1}>
											<Grid.Column>
												<SecondaryButton
													type='button'
													style={{ float: 'left' }}
													onClick={this.props.resetFocusServipayTerminal}
												>
													Fermer
												</SecondaryButton>
												<MainButton
													text={<Icon name='save' />}
													type='submit'
													style={{ float: 'left' }}
													isSubmitting={isSubmitting}
													disabled={
														Object.entries(errors).length > 0 &&
														errors.constructor === Object
													}
												>
													{newServipayTerminal ? 'Créer' : 'Enregistrer'}
												</MainButton>

												{!newServipayTerminal && (
													<RedButton
														text={<Icon name='trash' />}
														type='button'
														onClick={(e) => {
															if (e !== undefined) e.preventDefault();
															this.deleteFocus();
														}}
														style={{ float: 'right' }}
													>
														Supprimer
													</RedButton>
												)}
											</Grid.Column>
										</Grid.Row>

										<Grid.Row columns={1}>
											<Grid.Column>
												<AdminDataContainer
													ribbonColor='red'
													ribbonLabel='Général'
												>
													<GeneralForm centers={this.getCenterOptions()}/>
												</AdminDataContainer>
											</Grid.Column>
										</Grid.Row>
									</Grid>
								</Form>
							)}
						</Formik>
					)}
				</ElementFocus>
			</div>
		);
	}
}

const styles = {
	adminContainer: {
		height: '100%',
		width: '100%',
		paddingTop: 43,
		fontSize: 0,
		display: 'flex',
	},
	blocHeader: {
		backgroundColor: 'rgb(0, 147, 128)',
		padding: 10,
		width: '100%',
		borderRadius: '4px 4px 0 0',
	},
};

const mapStateToProps = (state) => {
	return {
		servipayTerminals: state.admin.servipayTerminals,
		centers: state.admin.centers
	};
};

const mapDispatchToProps = {
	adminGetAllCenters,
	adminGetAllServipayTerminal,
	adminGetServipayTerminalById,
	adminPatchServipayTerminal,
	adminDeleteServipayTerminal,
	resetFocusServipayTerminal,
	adminPostServipayTerminal,
	initNewServipayTerminal,
};

export default connect(mapStateToProps, mapDispatchToProps)(ServipayTerminal);
